// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","notesIntro":"_26_KI5tDI6AWZ62qH7zCBe","notesCard":"_1u6cscO9yXh_fAuOPnr42"};